var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DB8DB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CA0D1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("style", null, "\n            @font-face {\n                font-family: Monorale;\n                font-weight: 700;\n                font-style: normal;\n                src: url('/fonts/Monorale-Bold.woff') format('woff');\n                font-display: fallback;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#prefix__a)",
    width: 35,
    height: 35,
    rx: 5
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Monorale",
    fontSize: 26,
    fontWeight: "bold",
    letterSpacing: 2.167,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.604,
    y: 27
  }, "P")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logoIcon.bc59e846.svg";
export { ForwardRef as ReactComponent };